// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"526":"698165b2","648":"7124a742"}[chunkId] + ".chunk.js";
};